import { render } from "./AddAccountOrUserToProject.vue?vue&type=template&id=482af7e8&scoped=true"
import script from "./AddAccountOrUserToProject.vue?vue&type=script&lang=js"
export * from "./AddAccountOrUserToProject.vue?vue&type=script&lang=js"

import "./AddAccountOrUserToProject.vue?vue&type=style&index=0&id=482af7e8&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/acs-ui-builder/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-482af7e8"]])

export default __exports__